<template>
  <div class="quiz-question">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'QuizQuestion'
}
</script>



// WEBPACK FOOTER //
// src/components/global/submodule/partial/QuizQuestion.vue